import translations from 'ckeditor5/translations/de.js';
import premiumFeaturesTranslations from 'ckeditor5-premium-features/translations/de.js'

translations.de.dictionary = {
    ...translations.de.dictionary,
    ...premiumFeaturesTranslations.de.dictionary,
    'Line Height': 'Zeilenhöhe',
    'Styles': 'Stile',
    'Classes': 'Klassen',
    'Image spacing': 'Abstände',
    'HSpace': 'Abstand horizontal',
    'VSpace': 'Abstand vertikal',
};

translations.de.dictionary['Resize image (in %0)'] = 'Bildbreite (in %0)';

export default translations;